export function isArtEditingStatus(artStatus, campaignStatus) {
  return (
    artStatus === 'editing' ||
    campaignStatus === 'editing_art' ||
    campaignStatus === 'editing_arts'
  );
}

export function getCampaignArtProgressTitle(
  artStatus,
  campaignStatus,
  t,
) {
  const editing = isArtEditingStatus(artStatus, campaignStatus);

  return editing
    ? t('campaignChat.chat.editing_arts', 'Editando artes...')
    : t('campaignChat.chat.creating_arts', 'Gerando artes...');
}
